import { gql } from '@apollo/client';

export const orderBusinessCarQuery = gql`
  mutation Order($input: OrderInput!) {
    order(input: $input) {
      orderResult {
        orderId
      }
    }
  }
`;
